(() => {
  'use strict';

  const SELECTOR = '.lazyload';
  const supportsIO = 'IntersectionObserver' in window;

  const reveal = (element) => {
    if (!element || element.dataset.lazyLoaded === 'true') return;

    if (element.classList.contains('product-card-secondary') && window.matchMedia('(hover: none), (pointer: coarse)').matches) {
      element.dataset.lazyLoaded = 'skipped-mobile';
      element.remove();
      return;
    }
    element.dataset.lazyLoaded = 'true';

    const source = element.dataset.src;
    const sourceSet = element.dataset.srcset;
    const background = element.dataset.bg;

    if (sourceSet) element.setAttribute('srcset', sourceSet);
    if (source) element.setAttribute('src', source);
    if (background) element.style.backgroundImage = `url("${background.replace(/"/g, '\\"')}")`;

    const done = () => {
      element.classList.remove('lazyload');
      element.classList.add('lazyloaded');
    };

    if (element.tagName === 'IMG' && source) {
      if (element.complete) done();
      else {
        element.addEventListener('load', done, { once: true });
        element.addEventListener('error', done, { once: true });
      }
    } else {
      done();
    }
  };

  const observer = supportsIO
    ? new IntersectionObserver((entries, instance) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          instance.unobserve(entry.target);
          reveal(entry.target);
        });
      }, { rootMargin: '300px 0px' })
    : null;

  const watch = (root = document) => {
    root.querySelectorAll?.(SELECTOR).forEach((element) => {
      if (element.dataset.lazyObserved === 'true') return;
      element.dataset.lazyObserved = 'true';
      if (observer) observer.observe(element);
      else reveal(element);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => watch(), { once: true });
  } else {
    watch();
  }

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches(SELECTOR)) watch(node.parentElement || document);
        else watch(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
